import { Plugin } from '@nuxt/types'

const prometheus: Plugin = ({ app }) => {
  const router = <any>app.router
  const matchedRoute = router?.matcher?.match(app.context.route)

  if (app.context.req) {
    app.context.req.prometheus = {
      routeLabel: matchedRoute?.name,
      routePath: matchedRoute?.matched[0]?.path,
      shopId: app?.$shopConfig?.shopId,
    }
  }
}

export default prometheus
